
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue10 as ObiWindTrue10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-10.js';
 
 
 

 
 export const ObiWindTrue10 = createComponent({
   react: React,
   tagName: 'obi-wind-true-10',
   elementClass: ObiWindTrue10Element,
   events: {
     
   }
  });
 
 